import { CART_QUERY_NAME } from '@pylot-data/core-queries/cart'
import type { Cart } from '@pylot-data/pylotschema'
import { mutate, unstable_serialize } from 'swr'

/**
 * Revalida el carro que entrega useCart y devuelve el resultado nuevo.
 *
 * Se usa al iniciar sesión cuando no hay carro de invitado que fusionar (el
 * invitado no agregó productos, así que nunca se creó): no se llama a
 * mergeCarts, que exige un source_cart_id, y se trae el carro del cliente.
 */
export const refreshCart = (): Promise<
    { data?: { cart?: Cart } } | undefined
> =>
    // La key real de useCart es el array [CART_QUERY_NAME] (ver use-query.tsx).
    mutate(unstable_serialize([CART_QUERY_NAME]))
